import { render, staticRenderFns } from "./AStaffDetailContract.vue?vue&type=template&id=85f66a1a&scoped=true"
import script from "./AStaffDetailContract.vue?vue&type=script&lang=js"
export * from "./AStaffDetailContract.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailContract.vue?vue&type=style&index=0&id=85f66a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f66a1a",
  null
  
)

export default component.exports